import { render, staticRenderFns } from "./Forward30.vue?vue&type=template&id=72f45c09&"
import script from "./Forward30.vue?vue&type=script&lang=js&"
export * from "./Forward30.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports